<template>
  <section class="home-section bg-gradient pd-both container" :id="'featured-tag-'+tag.id">
    <a class="morein js-newpage" href="" @click.prevent="navigatorPush('Tag', { id: tag.id, title: tag.name })">{{ $t("ui.more") }}</a>
    <h2 class="row-title1">{{ tag.display_title || tag.name }}</h2>
    <episode-grid :episodes="tag.episodes" v-if="tag.episodes && tag.episodes.length" />
    <channel-grid :channels="tag.channels" v-else />
  </section>
</template>

<script>
import EpisodeGrid from '../EpisodeGrid.vue';
import ChannelGrid from '../ChannelGrid.vue';

export default {
  props: ['tag'],

  components: {
    'episode-grid': EpisodeGrid,
    'channel-grid': ChannelGrid,
  },
};
</script>
